import { render } from "./AdminSpaces.vue?vue&type=template&id=7ea5e894"
import script from "./AdminSpaces.vue?vue&type=script&lang=js"
export * from "./AdminSpaces.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__